module.exports = __webpack_public_path__ + "img/QR-img1.759a723a.png";